import { Box, Grid, Stack, Typography, useMediaQuery } from '@mui/material';

import React from 'react';
import TestimonialCard from './ReviewSection';

const visitData = [
  {
    icon: '/assets/images/Home/mobile/OBJECTS.png',
    title: '5 Years Warranty On Fabric',
    description:
      'Our curtain motors come with a 5-year warranty, ensuring reliable performance and long-term protection. You enjoy seamless control and we’ve got your investment covered.',
  },
  {
    icon: '/assets/images/Home/mobile/tool-icon.png',
    title: '1 Year FREE Service On Curtains & Blinds',
    description:
      'We stand by our quality. That’s why every Zeal installation includes 1 full year of free service. No surprise charges, no extra maintenance fees — just lasting performance and peace of mind. Because real quality shouldn’t come with recurring costs.',
  },
];

const steps = [
  {
    icon: '/assets/images/Product/icon1.png',
    label: (
      <>
        Schedule FREE <br />
        Home Visit
      </>
    ),
  },
  {
    icon: '/assets/images/Product/icon2.png',
    label: (
      <>
        Visit With <br />
        Curtain Fabrics
      </>
    ),
  },
  {
    icon: '/assets/images/Product/icon3.png',
    label: (
      <>
        Measure, Consult
        <br />
        Estimate
      </>
    ),
  },
];
const DotSeparator = () => (
  <Stack
    className="dote"
    direction="row"
    spacing={0.5}
    alignItems="center"
    justifyContent="center"
    sx={{ px: 1, ml: '0 !important', mt: '-42px !important' }}
  >
    {[...Array(3)].map((_, idx) => (
      <Box
        key={idx}
        sx={{
          width: idx === 1 ? 6 : 4,
          height: idx === 1 ? 6 : 4,
          bgcolor: idx === 1 ? '#8A2E2F' : '#ED2629',
          borderRadius: '50%',
        }}
      />
    ))}
  </Stack>
);
export default function ExpertHomeVisitSectionEstimate() {
  const isSmallScreen = useMediaQuery('(max-width:400px)');

  return (
    <Box sx={{ pt: 3 }}>
      <Box px={2}>
        <Typography
          className="merri-weather-text-bold"
          sx={{
            fontWeight: 800,
            backgroundImage: 'linear-gradient(to bottom, #ED2629, #7D2F2F)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: 41,
            lineHeight: 1.1,
            mb: 3,
            ml: 3,
          }}
        >
          Book A Expert <br />
          Home Visit.
        </Typography>

        <Box
          component="img"
          src="/assets/images/Home/mobile/home-visit.webp"
          alt="Expert Visit"
          sx={{
            width: '100%',
            maxWidth: 420,
            height: 'auto',
            borderRadius: 2,
            mb: 3,
          }}
        />
        <Typography className="merri-weather-text-lighter" sx={{ mb: 5, fontSize: 13, color: '#1E1E1E', mx: 3 }}>
          From expert advice to fast installation — our free home visit comes with total peace of mind. Get tailored
          recommendations, premium quality, and unmatched after-sales support, right from your first booking.
        </Typography>
      </Box>

      <TestimonialCard
        image="/assets/images/Home/mobile/reviewImageLeft.webp"
        quote="Zeal’s thermal curtains cut the heat—and my energy bill. Didn’t know curtains could make this much difference. Zeal Just did it."
        name="Salim A. Naser"
        rating={5}
        position="left"
      />
      <Box sx={{ p: 2, mt: 4 }}>
        <Stack direction="row" alignItems="center" justifyContent="center" flexWrap="wrap" spacing={3}>
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <Stack alignItems="center" spacing={1} textAlign="center" sx={{ ml: '0px !important' }}>
                <Box
                  component="img"
                  src={step.icon}
                  alt="Expert Visit"
                  sx={{
                    width: '100%',
                    maxWidth: isSmallScreen ? '49px' : '59px',
                    height: isSmallScreen ? '47px' : '57px',
                  }}
                />
                <Typography
                  variant="caption"
                  fontSize={isSmallScreen && '10px'}
                  className="merri-weather-text-bold"
                  sx={{
                    backgroundImage: 'linear-gradient(180deg, #ED2629, #7D2F2F)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  {step.label}
                </Typography>
              </Stack>
              {index < steps.length - 1 && <DotSeparator />}
            </React.Fragment>
          ))}
        </Stack>
      </Box>
      <TestimonialCard
        image="/assets/images/Home/mobile/reviewImageRight.webp"
        quote="Zeal curtains truly transformed my room — cooler in the day, cozy at night, and total control over light and privacy."
        name="Annie Alex"
        rating={5}
        position="right"
        gapOption="gapOption"
      />
      <Box px={5}>
        {visitData.map((item, index) => (
          <Grid
            container
            key={index}
            spacing={2}
            alignItems="flex-start"
            sx={{
              mb: 3,
              minHeight: 100, // Increased height for balance
            }}
          >
            {/* Icon */}
            <Grid item>
              <Box
                component="img"
                src={item.icon}
                alt={item.title}
                sx={{
                  width: 73,
                  height: 100,
                  objectFit: 'contain',
                }}
              />
            </Grid>

            {/* Text */}
            <Grid item xs>
              <Typography
                className="merri-weather-text-extra-bold"
                sx={{
                  backgroundImage: index < 2 ? 'linear-gradient(90deg, #ED2629, #7D2F2F)' : 'none',
                  WebkitBackgroundClip: index < 2 ? 'text' : 'unset',
                  WebkitTextFillColor: index < 2 ? 'transparent' : '#1b1b1b',
                  fontSize: 28,
                  lineHeight: 1.3,
                  mb: 1,
                  width: 172,
                  whiteSpace: 'normal',
                }}
              >
                {item.title}
              </Typography>

              <Typography
                className="merri-weather-text-lighter"
                sx={{ fontSize: 13, color: '#1E1E1E', whiteSpace: 'normal' }}
              >
                {item.description}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Box>
    </Box>
  );
}
